/* Marketing events use the existing Klaviyo onsite identity and Shopify consent. */
(() => {
  if (document.__hdsRoomVisualizerKlaviyo) return;
  document.__hdsRoomVisualizerKlaviyo = true;
  const seen = new WeakMap();
  const started = new WeakMap();
  let clientLoading;
  const consent = () => {
    try {
      const privacy = window.Shopify?.customerPrivacy;
      return privacy?.analyticsProcessingAllowed() === true && privacy?.marketingAllowed() === true;
    } catch { return false; }
  };
  function ensureClient() {
    if (typeof window.klaviyo?.track === 'function') return;
    if (clientLoading) return;
    clientLoading = true;
    // Public onsite ID of the existing Home Design Shops account; never a private API key.
    if (!document.querySelector('script[src*="static.klaviyo.com/onsite/js/"]')) {
      window._learnq = window._learnq || [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://static.klaviyo.com/onsite/js/XnWkxi/klaviyo.js?company_id=XnWkxi';
      document.head.appendChild(script);
    }
  }
  function track(properties) {
    if (!consent()) return;
    ensureClient();
    const deadline = Date.now() + 10000;
    const tick = () => {
      if (!consent()) return;
      try {
        if (typeof window.klaviyo?.track === 'function') {
          Promise.resolve(window.klaviyo.track('HDS Room Visualizer Used', properties)).catch(() => {});
          return;
        }
        if (Array.isArray(window._learnq)) {
          window._learnq.push(['track', 'HDS Room Visualizer Used', properties]);
          return;
        }
      } catch { return; }
      if (Date.now() < deadline) setTimeout(tick, 250);
    };
    tick();
  }
  document.addEventListener('room-visualizer:analytics', async event => {
    try {
      const el = event.target;
      const d = event.detail || {};
      if (el?.tagName !== 'HDS-ROOM-VISUALIZER') return;
      const selectedVariant = () => typeof el.currentVariant === 'function' ? el.currentVariant() : el.dataset.variantId;
      if (d.action === 'start') {
        started.set(el, { key: [d.cycle, d.attempt].join(':'), handle: el.dataset.productHandle, variantId: selectedVariant() });
        return;
      }
      if (d.action !== 'result' || !consent()) return;
      const key = [d.cycle, d.attempt].join(':');
      const snapshot = started.get(el);
      const current = snapshot?.key === key ? snapshot : { handle: el.dataset.productHandle, variantId: selectedVariant() };
      const handle = current.handle;
      if (!handle || !/^[a-z0-9-]+$/i.test(handle)) return;
      const variantId = current.variantId;
      let keys = seen.get(el);
      if (!keys) { keys = new Set(); seen.set(el, keys); }
      if (keys.has(key)) return;
      keys.add(key);
      // Snapshot the product before an asynchronous request or subsequent navigation.
      const origin = location.origin;
      const currency = window.Shopify?.currency?.active;
      const root = window.Shopify?.routes?.root || '/';
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 8000);
      let response;
      try {
        response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`, { signal: controller.signal, credentials: 'same-origin' });
        if (!response.ok) return;
        const product = await response.json();
        const variant = product.variants?.find(v => String(v.id) === String(variantId)) || product.variants?.[0];
        const rawImage = variant?.featured_image?.src || product.featured_image;
        if (!product.id || !product.title || !rawImage || !variant || !currency) return;
        const image = new URL(rawImage, origin);
        const url = new URL(`${root}products/${encodeURIComponent(handle)}`, origin);
        if (image.protocol !== 'https:' || url.origin !== origin) return;
        url.searchParams.set('variant', String(variant.id));
        const properties = {
          $event_id: `room-visualizer-${crypto.randomUUID()}`,
          ProductID: String(product.id), ProductName: product.title, ProductHandle: handle,
          VariantID: String(variant.id), VariantName: variant.title, SKU: variant.sku || '',
          ImageURL: image.href, URL: url.href, Brand: product.vendor || '',
          ProductType: product.type || '', Tags: product.tags || [],
          Price: Number(variant.price) / 100, Currency: currency,
          Available: variant.available === true,
          MaterialType: d.material_type === 'paint' ? 'paint' : 'wallpaper',
          RenderMode: ['fast', 'detailed', 'legacy'].includes(d.render_mode) ? d.render_mode : 'legacy',
        };
        if (Number.isFinite(variant.compare_at_price) && variant.compare_at_price > 0) properties.CompareAtPrice = variant.compare_at_price / 100;
        if (Number.isInteger(d.attempt) && d.attempt > 0) properties.AttemptNumber = d.attempt;
        if (Number.isFinite(d.duration_ms) && d.duration_ms >= 0) properties.DurationMs = Math.round(d.duration_ms);
        if (!Number.isFinite(properties.Price)) return;
        track(properties);
      } finally { clearTimeout(timeout); }
    } catch { /* Marketing must never interrupt the visualizer. */ }
  });
})();
